"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prDisplayLogicService', [
        '$filter',
        'prActiveReport',
        'prDisplayLogicConstants',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        function (
        // @ts-ignore
        $filter, 
        // @ts-ignore
        activeReport, 
        // @ts-ignore
        displayLogicConstants, 
        // @ts-ignore
        triggerOverrides, 
        // @ts-ignore
        OVERRIDE_EVENTS) {
            var translate = $filter('translate');
            var ID_LENGTH = 5;
            var ID_PREFIX = 'DISPLAY_';
            var DISPLAY_LOGICS = 'displayLogics';
            /**
             * generate a new ID for saved display logic
             */
            function generateID() {
                return generateIdHelper(ID_PREFIX);
            }
            function generateIdHelper(prefix) {
                var ret = '';
                var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                for (var i = 0; i < ID_LENGTH; i += 1) {
                    ret += possible.charAt(Math.floor(Math.random() * possible.length));
                }
                return prefix + ret;
            }
            /**
             * check if a string is a valid display logic ID
             */
            function isValidID(id) {
                return lodash_1.default.isString(id) && lodash_1.default.startsWith(id, ID_PREFIX);
            }
            /**
             * create a new display logic object
             */
            function getNewDisplayLogic() {
                return {
                    _id: generateID(),
                    name: translate('PR.NEW_DISPLAY_LOGIC'),
                    type: "and" /* AND */,
                    children: [
                        displayLogicConstants.getBasicDisplayLogicObj()
                    ]
                };
            }
            /**
             * get all saved display logics from report contextMeta
             */
            function getDisplayLogics() {
                return lodash_1.default.cloneDeep(activeReport.getMetadata(DISPLAY_LOGICS) || []);
            }
            /**
             * get saved display logic by id
             */
            function getDisplayLogic(id) {
                var allDisplayLogics = getDisplayLogics();
                // @ts-ignore
                return lodash_1.default.find(allDisplayLogics, { _id: id });
            }
            /**
             * save display logics
             */
            function setDisplayLogics(displayLogics) {
                activeReport.setMetadata(DISPLAY_LOGICS, displayLogics);
            }
            /**
             * check if the current report type should have relationship display logic
             */
            function shouldHave360DisplayLogic() {
                var configFlags = triggerOverrides({
                    event: OVERRIDE_EVENTS.CONFIG_FLAGS,
                    sync: true,
                    data: {}
                });
                return configFlags.shouldHave360DisplayLogic;
            }
            /**
             * get an array of display logic elements for validation
             * based on the following cases:
             * 	- when display logic has no category (default)
             * 	- when display logic has category
             * 		- metric
             * 		- relationship
             * 		- person metadata
             */
            function getElementsForValidation(displayLogic) {
                var category = lodash_1.default.get(displayLogic, 'displayLogic.category');
                if (category === "relationship" /* RELATIONSHIP */) {
                    return [
                        "relationshipOperator" /* OPERATOR */,
                        "relationshipValue" /* VALUE */,
                        "category" /* CATEGORY */
                    ];
                }
                else if (category === "personMetadata" /* PERSON_METADATA */) {
                    return [
                        "category" /* CATEGORY */,
                        "personMetadata" /* PERSON_METADATA */,
                        "personMetadataOperator" /* OPERATOR */,
                        "operand" /* OPERAND */
                    ];
                }
                else if (category === "rankableItems" /* RANKABLE_ITEMS */) {
                    return [
                        "category" /* CATEGORY */,
                        "rankableComparator" /* COMPARATOR */,
                        "operand" /* OPERAND */,
                        "rankableValue" /* VALUE */,
                        "rankableOperator" /* OPERATOR */
                    ];
                }
                var elements = [
                    "metric" /* METRIC */,
                    "field" /* FIELD */,
                    "operator" /* OPERATOR */,
                    "operand" /* OPERAND */
                ];
                if (category === "metric" /* METRIC */) {
                    elements.push("category" /* CATEGORY */);
                    return elements;
                }
                // no category (default)
                return elements;
            }
            return {
                generateID: generateID,
                generateIdHelper: generateIdHelper,
                isValidID: isValidID,
                getNewDisplayLogic: getNewDisplayLogic,
                getDisplayLogic: getDisplayLogic,
                getDisplayLogics: getDisplayLogics,
                setDisplayLogics: setDisplayLogics,
                shouldHave360DisplayLogic: shouldHave360DisplayLogic,
                getElementsForValidation: getElementsForValidation
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
